import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode, faList, faListUl, faChartLine } from '@fortawesome/free-solid-svg-icons';
import './BigData.css';
import ViolinChart from './ViolinChart';
import ViolinChartData from './ViolinChartData';

function ProjectsViolinChart() {
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedField, setSelectedField] = useState('');

  // Extract unique project names
  const projectNames = [...new Set(ViolinChartData.map(data => data.projectName))];

  // Extract field names, excluding projectId and task
  const fieldNames = Object.keys(ViolinChartData[0]).filter(
    key => key !== 'projectId' && key !== 'task'
  );


  return (
    <div>
      <div className="main-content min-h-[500px] flex flex-col justify-center">
        <div className='flex justify-center text-2xl text-yellow-200 mb-16'>Kalam Electrical Project Consultatnts - Violin Chart</div>
        
        <div className='flex justify-center text-lg text-yellow-200 mb-16'>
          <select
            value={selectedProject}
            onChange={e => setSelectedProject(e.target.value)}
            className="bg-gray-800 text-white p-2 rounded-md mr-8"
          >
            <option value="">Select Project</option>
            {projectNames.map((name, index) => (
              <option key={index} value={name}>
                {name}
              </option>
            ))}
          </select>

          <select
            value={selectedField}
            onChange={e => setSelectedField(e.target.value)}
            className="bg-gray-800 text-white p-2 rounded-md"
          >
            <option value="">Select Parameter</option>
            {fieldNames.map((field, index) => (
              <option key={index} value={field}>
                {field}
              </option>
            ))}
          </select>
        </div>

        <div className="min-h-[500px]">
          {ViolinChart ()}
        </div>
      </div>
      <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>
  );
};

export default ProjectsViolinChart;
